import { render, staticRenderFns } from "./remittanceEntryBusiness.vue?vue&type=template&id=73b5e5c3&scoped=true"
import script from "./remittanceEntryBusiness.vue?vue&type=script&lang=js"
export * from "./remittanceEntryBusiness.vue?vue&type=script&lang=js"
import style0 from "./remittanceEntryBusiness.vue?vue&type=style&index=0&id=73b5e5c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5e5c3",
  null
  
)

export default component.exports